<h3 class="yes-no-cta__heading">{{ content.headingText }}</h3>
<div class="yes-no-cta__buttons">
  <vm-button
    id="yesButton"
    class="yes-no-cta__button"
    [level]="ButtonLevel.TERTIARY"
    (buttonClick)="pressedYes.emit(true)">
    {{ content.yesButtonText }}
  </vm-button>

  <vm-button
    id="noButton"
    class="yes-no-cta__button"
    [level]="ButtonLevel.TERTIARY"
    [styles]="[ButtonStyle.OUTLINE]"
    (buttonClick)="pressedYes.emit(false)">
    {{ content.noButtonText }}
  </vm-button>
</div>
